import { render } from "./PurchaseOrderAdd.vue?vue&type=template&id=f7837af6&ts=true"
import script from "./PurchaseOrderAdd.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__